/**
 * Apple StoreKit product identifiers (auto-renewable subscriptions).
 *
 * Registered in App Store Connect as:
 *   monthly   — $14.99 / 1 month
 *   quarterly — $39.99 / 3 months
 *   annual    — $79.99 / 1 year
 *
 * Prices and currencies are intentionally NOT hardcoded here — StoreKit's
 * localized `displayPrice` is the only price ever shown in the UI.
 */

export type ApplePlanKey = "monthly" | "quarterly" | "annual";

export interface AppleProductDefinition {
  planKey: ApplePlanKey;
  productId: string;
  /** Provisional until confirmed in App Store Connect. */
  provisional: true;
}

export const APPLE_PRODUCT_IDS: Record<ApplePlanKey, string> = {
  monthly: "app.mblearn.study.pro.monthly",
  quarterly: "app.mblearn.study.pro.quarterly",
  annual: "app.mblearn.study.pro.annual",
};

export const APPLE_PRODUCTS: AppleProductDefinition[] = (
  Object.keys(APPLE_PRODUCT_IDS) as ApplePlanKey[]
).map((planKey) => ({
  planKey,
  productId: APPLE_PRODUCT_IDS[planKey],
  provisional: true,
}));

export function getAppleProductId(planKey: ApplePlanKey): string {
  return APPLE_PRODUCT_IDS[planKey];
}
